import { MerchantThin } from "domain/merchant";
import ProducerInvitation from "./producerInvitation";
import { ProducerAccount } from "./producerAccount";
import UserGroup from "domain/userGroup";
import { CustomerWillSellText } from "common/formatters/useCustomerWillSellText";

export class Producer {
  id: string = "";
  merchant: MerchantThin = null;
  userId: string = "";
  firstName: string = null;
  lastName: string = null;
  businessName: string = null;
  producerGroups: UserGroup[] = [];
  accountIds: string[] = [];
  phone: string = "";
  postalCode: string = "";
  address: string = "";
  city: string = "";
  state: string = "";
  email: string = "";
  willSellDefaultValue: boolean = null;
  canMakeOffer: boolean = false;
  canLogin: boolean = false;
  maxOfferQuantity: number = 0;
  maxErpQuantity: number = 0;
  maxDailyQuantity: number = 0;
  maxCropYearQuantity: number = 0;
  preferredLocationId: string = null;
  preferredTraderId: string = null;
  useBusinessName: boolean = false;
  isActive: boolean = false;
  additionalEmails: string = null;
  additionalPhones: string = null;
  producerStatus: ProducerStatus = 0;
  signupStatus: SignupStatus = null;
  producerInvitation: ProducerInvitation = null;
  accounts: ProducerAccount[] = [];
};

export enum ProducerStatus {
  NotInvited = 0,
  Pending,
  Active,
  Removed
}

export const AllProducerStatuses: ProducerStatus[] = [
  ProducerStatus.NotInvited,
  ProducerStatus.Pending,
  ProducerStatus.Active,
  ProducerStatus.Removed
];

export enum SignupStatus {
  UserRegistered = 1,
  PasswordVerified,
  CanLogin
}

export type CustomerWillDefault = { action: string, value: boolean };

export function getProducerStatusDescription(status: ProducerStatus): string {
  switch (status) {
    case ProducerStatus.NotInvited:
      return "Not Invited";
    case ProducerStatus.Pending:
      return "Pending";
    case ProducerStatus.Active:
      return "Active";
    case ProducerStatus.Removed:
      return "Removed";
    default:
      return "";
  }
}

export function getProducerDisplayName(producer: Nullish<Producer>): string {
  if (producer == null)
    return "";
  return producer.useBusinessName ? `${producer.businessName}` : `${producer.lastName}, ${producer.firstName}`;
}

export function getProducerGroupsName(producer: Producer): string {
  if (producer == null)
    return "";
  return producer.producerGroups != null ? producer.producerGroups
    .map(t => t.name)
    .join(", ") : "";
}

export function getProducerAccountsDisplayName(producer: Producer): string {
  if (producer == null)
    return "";
  return producer.accounts != null ? producer.accounts.filter(p => p.isPrimaryUser)
    .map(p => p.accountId)
    .filter(id => id?.length > 0)
    .join(", ") : "";
}

export function getProducerStatus(producer: Producer): string {
  if (producer == null) return "";
  return getProducerStatusDescription(producer.producerStatus);
}

export function getCustomerWillDefaults(customerWillSellText: CustomerWillSellText): CustomerWillDefault[] {
  return [
    { action: customerWillSellText.formatValue(true), value: true },
    { action: customerWillSellText.formatValue(false), value: false }
  ]
}